export default [
    {
        type: "text",
        id: 1,
        title: "Persönliche Angaben",
        items: [
            {
                id: 1,
                type: "medium",
                text: "Name des Tutors:",
            },
            {
                id: 2,
                type: "small",
                text: "Semester:",
            },
            {
                id: 3,
                type: "medium",
                text: " Studiengang:",
            },
        ],
    },
    {
        type: "special",
        id: 2,
        items: [
            {
                id: 4,
                text: "Teilnahme:",
                label: [
                    {
                        id: 1,
                        text: "Pflicht-LV",
                    },
                    {
                        id: 2,
                        text: "Wahlpfl.-LV",
                    },
                    {
                        id: 3,
                        text: "Wahl-LV",
                    },
                ],
            },
        ],
    },
    {
        type: "uni",
        id: 3,
        items: [
            {
                id: 5,
                text: "Die Übung war übersichtlich und verständlich.",
            },
            {
                id: 6,
                text: "Der inhaltliche Aufbau der Übung war logisch/nachvollziehbar.",
            },
            {
                id: 7,
                text: "Die Übung war sinnvoll mit der Vorlesung gekoppelt.",
            },
            {
                id: 8,
                text: "Die Übung hat die Inhalte der Vorlesung angemessen vertieft.",
            },
            {
                id: 9,
                text: "Der Schwierigkeitsgrad des Stoffes war angemessen.",
            },
            {
                id: 10,
                text: "Der Umfang des Stoffes war dem Zeitrahmen angemessen.",
            },
            {
                id: 11,
                text: "Der Zeitaufwand für die Übung insgesamt (inkl. Vor- und Nachbereitung) war angemessen.",
            },
            {
                id: 12,
                text: "Die Übung baute auf den in der Vorlesung vermittelten Inhalten gut auf.",
            },
            {
                id: 13,
                text: "Der Tutor/Die Tutorin konnte auf Rückfragen kompetent reagieren.",
            },
            {
                id: 14,
                text: "Der Tutor/Die Tutorin war motiviert und engagiert.",
            },
            {
                id: 15,
                text: "Der Tutor/Die Tutorin ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
            },
            {
                id: 16,
                text: "Der Tutor/Die Tutorin war stets gut vorbereitet.",
            },
            {
                id: 17,
                text: "Der Tutor/Die Tutorin konnte die Lerninhalte verständlich vermitteln.",
            },
            {
                id: 18,
                text: "Ich habe davon profitiert, die Veranstaltung regelmäßig besucht zu haben.",
            },
            {
                id: 19,
                text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
            },
            {
                id: 20,
                text: "Die Übung bot ausreichend Feedback zum eigenen Wissensstand.",
            },
            {
                id: 21,
                text: "Insgesamt fand ich die Veranstaltung gut.",
            },
        ],
    },
    {
        type: "text",
        id: 4,
        items: [
            {
                id: 22,
                text: "Lob und Kritik zu meinem Tutor",
            },
        ],
    },
];